import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { getCurrentLangCode } from '../../reducers/i18n';
import StarterSetCartForm from '../cartforms/StarterSetCartForm';
import Text from '../common/Text';
import SewpatGallery from '../sewpatgallery/SewpatGalleryEmbed';
import About from './About';
import CouponBar from './CouponBar';
import HomeStep from './HomeStep';
import NewsLetterBar from './NewsLetterBar';
import Picture from '../image/CloudFrontPicture';
import { SchriftLogoWithSubLine } from '../Logo';
import { getHasSeenHome } from '../../reducers/userdata';
import YouTubeVid from './YouTubeVid';

const SchnittmacherLogo = <figure className='schnoffle-homestep-logo'><Picture src='logo-schnittmuster-berlin.png' webp='logo-schnittmuster-berlin.webp' altText='Logo Schnittmuster Berlin' png schnoffle /></figure>;
const StoffloveLogo = <figure className='schnoffle-homestep-logo'><Picture src='stofflove-logo-stoffe-so-einzigartig-wie-du-selbst.png' webp='stofflove-logo-stoffe-so-einzigartig-wie-du-selbst.webp' altText='Logo www.Stoff.love Berlin' png schnoffle /></figure>;

const Home = ({ language, hasSeenHome }) => (
    <div>
        <About full={!hasSeenHome} />
        <Text.Divider margin='1.61em 0 1em' />
        <YouTubeVid />
        <Text.Divider margin='1.61em 0 0' />
        <Text.Heading center level={2} margin='0.81rem 0 0 0'>
            <FormattedMessage
                id='HOME_STEPS_TO_SCHNOFF'
                defaultMessage='In 3 Schritten zu Deinem Schnoff'
            />
        </Text.Heading>
        <Text>
            <HomeStep number='1'>
                <Text.Heading level={4}>
                    <FormattedMessage
                        id='SEWPAT_SHORT'
                        defaultMessage='Schnitt'
                    />
                </Text.Heading>
                <FormattedMessage
                    id='HOME_STEP_ONE_TEXT'
                    defaultMessage='Wähle Deinen Lieblingsschnitt aus den professionellen Schnittmustern von Schnittmuster Berlin.'
                />
                {SchnittmacherLogo}
            </HomeStep>
        </Text>
        <SewpatGallery />
        <Text.Divider margin='1.61em 0 0' />
        <Text>
            <HomeStep number='2'>
                <Text.Heading level={4}>
                    <FormattedMessage
                        id='FABRIC_SHORT'
                        defaultMessage='Stoff-Motiv'
                    />
                </Text.Heading>
                <FormattedMessage
                    id='HOME_STEP_TWO_TEXT'
                    defaultMessage='Wähle aus über 20.000 Motiven von über 500 internationalen Textildesignern. Gestalte das Design in Deinen Lieblingsfarben. Färbe um, lege gezielt Farben fest, nimm weniger satte und helle Töne.'
                />
                {StoffloveLogo}
            </HomeStep>
        </Text>
        <Text.Divider margin='1.61em 0 0' />
        <NewsLetterBar />
        <StarterSetCartForm />
        <Text.Divider margin='1.61em 0 0' />
        <Text>
            <HomeStep number='3'>
                <Text.Heading level={4}>
                    <FormattedMessage
                        id='SCHNOFF_SHORT'
                        defaultMessage='Nähpaket (Schnoff)'
                    />
                </Text.Heading>
                <FormattedMessage
                    id='HOME_STEP_THREE_TEXT'
                    defaultMessage='Bestehend aus Mehrgrößen-Papierschnitt, Nähanleitung + nach Deinen Vorgaben gedruckter Stoff für perfekte Unikate.'
                />
                <SchriftLogoWithSubLine className='schnoffle-homestep-logo-schnoffle' />
            </HomeStep>
            {hasSeenHome ?
                <Picture src='schnitt-stoff-schnoffle-v1.jpg' webp='schnitt-stoff-schnoffle-v1.webp' altText='Abbildung Schnitt + Stoff = Schnoff' schnoffle />
                : <Picture src='schnoffle-paket-schnitt-stoff-berlin.jpg' webp='schnoffle-paket-schnitt-stoff-berlin.webp' altText='Foto vom Nähpaket' schnoffle />}
        </Text>
        <CouponBar />
    </div>
);

const makeMapStateToProps = initialState => {
    const language = getCurrentLangCode(initialState);
    const hasSeenHome = getHasSeenHome(initialState);
    const mapStateToProps = () => (
        {
            language,
            hasSeenHome,
        }
    );
    return mapStateToProps;
};

export default connect(makeMapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/components/home/Home.js